<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 40 40" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M25.8 23.7h-4.4v-4.4c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v4.4H14c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5h4.4V31c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-4.4h4.4c.8 0 1.5-.7 1.5-1.5s-.6-1.4-1.5-1.4z" />
        <path d="M30.3 4.9V2.7c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v2.2H12.6V2.7c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5v2.2H1v22.5c0 6.3 5.1 11.4 11.4 11.4h15.2c6.3 0 11.4-5.1 11.4-11.4V4.9h-8.7zM9.7 7.8v.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-.7h14.8v.7c0 .8.7 1.5 1.5 1.5s1.5-.7 1.5-1.5v-.7h5.8v4.6H3.9V7.8h5.8zm17.9 28.1H12.4c-4.7 0-8.5-3.8-8.5-8.5V15.3h32.2v12.1c0 4.7-3.8 8.5-8.5 8.5z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
